var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.order
    ? _c("div", { staticClass: "order-details--type my-5 mr-10" }, [
        _vm.order.SaleAreaId == 1
          ? _c("div", { staticClass: "flex-start-start" }, [
              _c(
                "div",
                {
                  class: {
                    "tagIcon-bo-s1": !_vm.white,
                    "tagIcon-white": _vm.white,
                  },
                },
                [
                  _c("i", { staticClass: "fie-icon_store" }),
                  _c("span", [_vm._v("Table " + _vm._s(_vm.order.Table))]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.SaleAreaId == 2
          ? _c("div", { staticClass: "flex-start-start" }, [
              _c(
                "div",
                {
                  class: {
                    "tagIcon-bo-s2": !_vm.white,
                    "tagIcon-white": _vm.white,
                  },
                },
                [
                  _c("i", { staticClass: "fie-icon_on-site" }),
                  _c("span", [_vm._v("Sur place")]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.SaleAreaId == 3
          ? _c("div", { staticClass: "flex-start-start" }, [
              _c(
                "div",
                {
                  class: {
                    "tagIcon-bo-p2": !_vm.white,
                    "tagIcon-white": _vm.white,
                  },
                },
                [
                  _c("i", { staticClass: "fie-icon_takeaway" }),
                  _c("span", [_vm._v("A emporter")]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.order.SaleAreaId == 4 && (!_vm.order.stuart_job_id || _vm.white)
          ? _c("div", { staticClass: "flex-start-start" }, [
              _c(
                "div",
                {
                  class: {
                    "tagIcon-bo-p1": !_vm.white,
                    "tagIcon-white": _vm.white,
                  },
                },
                [
                  _c("i", { staticClass: "fie-icon_delivery" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Livraison")]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.white && _vm.order.stuart_job_id
          ? _c(
              "a",
              {
                staticClass:
                  "tagIcon-bo-p1 color-bo-p1 hover-color-bo-p1 hover-opacity",
                attrs: {
                  target: "_blank",
                  href:
                    "https://dashboard.stuart.com/jobs/" +
                    _vm.order.stuart_job_id,
                },
              },
              [
                _c("i", { staticClass: "fie-icon_delivery" }),
                _vm._v(" "),
                _c("span", [_vm._v("Livraison")]),
              ]
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }